// @flow
/**
 * @module Sagas/User
 * @desc User
 */
import md5 from 'md5';
import { all, delay, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { push } from '../modules/history';
import { ActionTypes, ApiServer } from '../constants';

/**
 * Login
 */
export function* login(action) {
  try {
    const { username, password, captcha, nextUrl } = action.payload;

    const { token, interfaceVersion, timezone } = yield fetch(ApiServer, {
      method: 'post',
      credentials: 'include',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      // credentials: 'include',
      // headers: {
      //   Origin: 'https://api.webproject.com.br',
      //   Referer: 'https://api.webproject.com.br/graphql?',
      //   'X-CSRFToken': 'PUXNwqSVjgOWjuUwBIprLa0blSDf5lP4',
      //   'Accept': 'application/json',
      //   'Content-Type': 'application/json',
      // },
      body: `{"query":"mutation{getToken(username:\\"${username}\\", password:\\"${password}\\", captchaToken:\\"${captcha}\\"){__typename,... on GetTokenSuccess{token,interfaceVersion,timezone},... on GetTokenFailedOther{errorMessage},... on InvalidCaptchaToken{errorMessage},... on ErrorValidatingCaptcha{errorMessage}}}","variables":null}`,
    })
      .catch(() => {
        throw Error('Server Connection Error');
      })
      .then((response) => response.json())
      .then((json) => {
        if (json.data.getToken.__typename === 'GetTokenSuccess') {
          return json.data.getToken;
        }
        if (
          ['GetTokenFailedOther', 'InvalidCaptchaToken', 'ErrorValidatingCaptcha'].includes(
            json.data.getToken.__typename,
          )
        ) {
          throw Error(json.data.getToken.__typename);
        }
      });

    // if (token == undefined) {
    //   console.warn('TOKEN....');
    // }
    //
    // console.warn('TOKEN: ', token);

    if (interfaceVersion === '2.0.0') {
      yield put({
        type: ActionTypes.USER_LOGIN_SUCCESS,
        payload: { token, timezone },
      });

      if (nextUrl) {
        yield push(nextUrl);
      } else {
        yield push('/home/');
      }
    } else if (nextUrl) {
      yield (window.location.href = nextUrl);
    } else {
      yield (window.location.href = '/home/');
    }
  } catch (err) {
    // console.warn('AUTH ERROR: ', err);
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.USER_LOGIN_FAILURE,
      payload: err.message,
    });
  }
}

/**
 * Login With Google
 */
export function* loginWithOpenID(action) {
  try {
    const { idToken, platform, nextUrl } = action.payload;

    const { token, interfaceVersion, newUserRegistered } = yield fetch(ApiServer, {
      method: 'post',
      credentials: 'include',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      // credentials: 'include',
      // headers: {
      //   Origin: 'https://api.webproject.com.br',
      //   Referer: 'https://api.webproject.com.br/graphql?',
      //   'X-CSRFToken': 'PUXNwqSVjgOWjuUwBIprLa0blSDf5lP4',
      //   'Accept': 'application/json',
      //   'Content-Type': 'application/json',
      // },
      body: `{"query":"mutation{loginWithOpenId(idToken:\\"${idToken}\\", platform:\\"${platform}\\"){__typename,... on OpenIdConnectSuccess{token,interfaceVersion,newUserRegistered},... on GetTokenFailedOther{errorMessage}}}","variables":null}`,
    })
      .catch(() => {
        throw Error('Server Connection Error');
      })
      .then((response) => response.json())
      .then((json) => {
        if (json.data.loginWithOpenId.__typename === 'OpenIdConnectSuccess') {
          return json.data.loginWithOpenId;
        }
        if (['GetTokenFailedOther'].includes(json.data.loginWithOpenId.__typename)) {
          toast.error(json.data.loginWithOpenId.errorMessage);
          throw Error(json.data.loginWithOpenId.__typename);
        }
      });

    // if (token == undefined) {
    //   console.warn('TOKEN....');
    // }
    //
    // console.warn('TOKEN: ', token);

    if (interfaceVersion === '2.0.0') {
      yield put({
        type: ActionTypes.USER_GOOGLE_LOGIN_SUCCESS,
        payload: { token, newUserRegistered },
      });

      if (nextUrl) {
        yield push(nextUrl);
      } else {
        yield push('/home/');
      }
    } else if (nextUrl) {
      yield (window.location.href = nextUrl);
    } else {
      yield (window.location.href = '/home/');
    }
  } catch (err) {
    // console.warn('AUTH ERROR: ', err);
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.USER_GOOGLE_LOGIN_FAILURE,
      payload: err.message,
    });
  }
}

/**
 * verifyToken
 */
export function* verifyToken(action) {
  try {
    const { token, nextUrl } = action.payload;

    if (token) {
      const newToken = yield fetch(ApiServer, {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: `{"query":"mutation{refreshToken(input:{clientMutationId: \\"${md5(
          Math.random() + new Date().toString(),
        )}\\", token:\\"${token}\\"}){__typename,... on RefreshTokenSuccess{token},... on RefreshTokenFailed{message}}}","variables":null}`,
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.data.refreshToken.__typename === 'RefreshTokenSuccess') {
            return json.data.refreshToken.token;
          }

          if (json.data.refreshToken.__typename === 'RefreshTokenFailed') {
            throw json.data.refreshToken.message;
          }
        });

      yield put({
        type: ActionTypes.USER_VERIFY_TOKEN_SUCCESS,
        payload: newToken,
      });

      if (nextUrl) {
        yield push(nextUrl);
      }
    } else {
      /* istanbul ignore next */
      yield put({
        type: ActionTypes.USER_VERIFY_TOKEN_FAILURE,
        payload: 'NO_TOKEN_PROVIDED',
      });
    }
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.USER_VERIFY_TOKEN_FAILURE,
      payload: err,
    });
  }
}

/**
 * Set unverified token
 */
export function* setTokenUnverified() {
  try {
    yield delay(500);
    yield put({
      type: ActionTypes.USER_UNVERIFY_TOKEN_SUCCESS,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.USER_UNVERIFY_TOKEN_FAILURE,
      payload: err,
    });
  }
}

/**
 * Logout
 */
export function* logout(action) {
  const { redirectOnLogoff } = action.payload;

  try {
    yield put({
      type: ActionTypes.USER_LOGOUT_SUCCESS,
    });
    yield (window.location.href = redirectOnLogoff || '/logoff/');
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.USER_LOGOUT_FAILURE,
      payload: err,
    });
  }
}

/**
 * User Sagas
 */
export default function* root() {
  yield all([
    takeLatest(ActionTypes.USER_LOGIN_REQUEST, login),
    takeLatest(ActionTypes.USER_GOOGLE_LOGIN_REQUEST, loginWithOpenID),
    takeLatest(ActionTypes.USER_VERIFY_TOKEN_REQUEST, verifyToken),
    takeLatest(ActionTypes.USER_UNVERIFY_TOKEN_REQUEST, setTokenUnverified),
    takeLatest(ActionTypes.USER_LOGOUT_REQUEST, logout),
  ]);
}
